var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { CloseWithoutBorder } from '../../../assets/images';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
var StockAvailability = function (_ref) {
    var _data$OnHandQuantity, _data$ProjectedQuanti;
    var onClose = _ref.onClose, data = _ref.data;
    console.log("dataaaa", data);
    var formData = [{
            type: FormItemTypes.ContainerItem,
            columnSize: 12,
            name: 'header',
            padding: '16px 20px',
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'headername',
                    children: 'Available stock',
                    fontSize: 'xl',
                    fontWeight: 'strong',
                    columnSize: true
                }, {
                    type: FormItemTypes.IconButton,
                    label: '',
                    name: '',
                    value: null,
                    columnSize: 1,
                    children: /*#__PURE__*/ React.createElement("img", {
                        src: CloseWithoutBorder
                    }),
                    onClick: function () {
                        onClose();
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            padding: '8px 20px',
            pb: '25px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'On hand stock    :',
                            columnSize: true,
                            fontSize: 'sm',
                            color: 'secondary.500',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'OnHandQuantity',
                            value: (_data$OnHandQuantity = data === null || data === void 0 ? void 0 : data.OnHandQuantity) !== null && _data$OnHandQuantity !== void 0 ? _data$OnHandQuantity : 0,
                            columnSize: 4,
                            disabled: true,
                            inputProps: {
                                style: {
                                    textAlign: 'right'
                                }
                            }
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Projected stock  :',
                            columnSize: true,
                            fontSize: 'sm',
                            color: 'secondary.500',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'ProjectedQuantity',
                            value: (_data$ProjectedQuanti = data === null || data === void 0 ? void 0 : data.ProjectedQuantity) !== null && _data$ProjectedQuanti !== void 0 ? _data$ProjectedQuanti : 0,
                            columnSize: 4,
                            disabled: true,
                            inputProps: {
                                style: {
                                    textAlign: 'right'
                                }
                            }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data,
                        success: true
                    })];
            });
        }); },
        gridProps: {
            spacing: 0
        }
    }));
};
export default StockAvailability;
